












































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Button, Pagination } from "ant-design-vue";
import CList from "@/components/CList/index.vue";
import SingleEdit from "./edit.vue";

@Component({
  name: "SingleSign",
  components: {
    CList,
    SingleEdit,
    AButton: Button,
    APagination: Pagination
  }
})
export default class SingleSign extends Base {
  private pageNum = 1;
  private total = 0;
  private pageSize = 20;
  private dataSource: any[] = [];
  private checkedMap: any = {};
  private isCheckedAll = false;

  private created() {
    this._created();
    this.getList();
  }

  private edit(obj: any) {
    (this.$refs as any).singleEdit.changeVisible(obj);
  }

  private async getList() {
    this.dataSource = [];
    const res = await this.$api.SsoInfoList({
      pageNum: this.pageNum,
      pageSize: this.pageSize
    });
    if (res && res.code === 200) {
      this.total = res.total;
      this.dataSource = Array.from(res.rows, (item) => Object.assign({}, item, { passwordShow: false }));
    }
    return res;
  }

  /**
   * 全选
   * @param {boolean} 来源是否翻页
   */
  private checkAll(page: boolean) {
    if (page === void 0) {
      this.isCheckedAll = !this.isCheckedAll;
    }

    if (this.isCheckedAll) {
      this.dataSource.map((item: any) => {
        if (this.checkedMap[item.id] === void 0 || page === void 0) {
          this.$set(this.checkedMap, item.id, true);
        }
      });
    } else {
      this.checkedMap = {};
    }
  }

  /**
   * 行内checkbox点击事件
   */
  private checkboxChange(id: number) {
    if (this.checkedMap[id]) {
      this.$set(this.checkedMap, id, false);
    } else {
      this.$set(this.checkedMap, id, true);
    }
  }

  private changePasswordShow(idx: number) {
    this.$set(this.dataSource[idx], "passwordShow", !this.dataSource[idx].passwordShow);
  }

  private async onChange() {
    const res = await this.getList();
    if (res && res.code === 200 && this.isCheckedAll) {
      this.checkAll(true);
    }
  }

  private async onShowSizeChange() {
    this.pageNum = 1;

    // 改变分页尺寸后，清空选中项目
    this.checkedMap = {};
    const res = await this.getList();
    if (res && res.code === 200 && this.isCheckedAll) {
      this.checkAll(true);
    }
  }

  private onDelete() {
    if (this.delParams.length) {
      this._confirm({
        content: "确定删除吗？",
        onOk: async () => {
          const res = await this.$api.SsoInfoDel(this.delParams);
          if (res && res.code === 200) {
            this.$message.success("删除成功");
            this.onChange();
          }
        }
      });
    }
  }

  private get delParams() {
    const _return: number[] = [];
    Object.keys(this.checkedMap).map((key: string) => {
      if (this.checkedMap[key]) {
        _return.push(Number(key));
      }
    });
    return _return;
  }
}
